

import React,{Component} from 'react';

 import {Link} from 'react-router-dom';

 
class issuesLoop extends Component{

 
render()
{
    const {data} = this.props;

    const issueList = data.map(issue =>
        {
            let updateLink = `/gitsearch/UpdatesIsssues/${issue.key}/${issue.IssueState}/${issue.Issue}/${issue.ProgLang}`;
            let deleteLink = `/gitsearch/DeleteIsssues/${issue.key}`;
            let viewLink = `/gitsearch/issues/view/${issue.Issue}/${issue.ProgLang}/${issue.IssueState}`;

            return(
            <li key={issue.key}>
          
            <section className="list-left">
            <h5 className="title">Issue: {issue.Issue} </h5>
            <span className="adprice">State: {issue.IssueState}</span>
            <p className="catpath">Programming Language » {issue.ProgLang}</p>
            </section>
            <section className="list-right">
            <span className="cityname"><Link to={viewLink}>View Issue</Link></span>
            <span className="date"><Link to={updateLink}>Update Issue</Link></span>
            <span className="cityname"><Link to={deleteLink}>Delete Issue</Link></span>
            
            </section>
            <div className="clearfix"></div>
            </li> 
            )

        });

return(

            
        <div>
        {issueList}

        </div>   
           
);

}


}




export default issuesLoop;


